import React from "react";
import Checkbox from '@material-ui/core/Checkbox';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Box from "@material-ui/core/Box";
const useStyles = makeStyles({
  checkMark:props=>({
    color: props.mainBg+ "!important",
    padding: 4,
    "&:hover": {
      background: props.secondaryBg + "!important",
    },
    "& >span>svg": {
      fontSize: '1rem'
    },
  }),
  check:{
    "& .Mui-disabled": {
      color: 'rgba(0, 0, 0, 0.26)!important',
      backgroundColor: 'transparent!important',
    },
  }
});
export default function MaterialUiCheckbox(props) {
  const classes = useStyles(props.cardStyle);
  return (
    <span className={classes.check}>
      <Checkbox
        checked={props.checkStatus ? true : false}
        onChange={props.checkClick}
        value={props.value}
        className={classes.checkMark}
        disabled={props.checkDisable}
        size="small"
      />
      {props.label!==undefined?
          <Box display="inline">
            <Typography variant="caption" display="inline">
              {props.label}
            </Typography>
          </Box>
        :''
      }
    </span>
  );
}
